import { useRouter } from 'next/router';

import { CommonLoggerEventName } from '@/constants/logs/common';
import { LoggerParams, Payload } from '@/types/log';
import Firebase from '@/utils/firebase';
import { getPageName, mobileLogger } from '@/utils/logger';
import { addActionForRum } from '@/utils/report';

const useLogger = (): {
  log: (params: LoggerParams, options?: { googleAnalytics?: boolean; datadogRum?: boolean }) => void;
  pageView: (userAgent: string, payloadParams?: Payload) => void;
} => {
  const router = useRouter();

  const pageViewLog = (userAgent: string, payloadParams?: Payload) => {
    const pageName = getPageName(router);
    const envParameters = Firebase.getUserServiceEnvironmentProperty(userAgent);

    /* DD는 페이지뷰 자동 수집이라 GA만 수집*/
    mobileLogger({
      logger: {
        eventName: CommonLoggerEventName.PageView,
        pageName,
        payload: {
          ...(router.query as Payload),
          ...payloadParams,
          ...envParameters,
        },
      },
    });
  };

  const log = (
    params: LoggerParams,
    options?: {
      googleAnalytics?: boolean;
      datadogRum?: boolean;
    }
  ) => {
    const { googleAnalytics = true, datadogRum = true } = options || {
      googleAnalytics: true,
      datadogRum: true,
    };
    const { eventName, payload } = params;
    const pageName = getPageName(router);

    if (googleAnalytics) {
      mobileLogger({
        logger: {
          eventName: eventName,
          pageName,
          payload,
        },
      });
    }

    if (datadogRum) {
      // DataDog에는 원래 eventName 그대로 전송
      addActionForRum(eventName, payload);
    }
  };

  return {
    log: log,
    pageView: pageViewLog,
  };
};

export default useLogger;
